<nz-layout
  class="!h-screen !flex-col !overflow-hidden"
  style="
    background: linear-gradient(
      135deg,
      rgb(17, 49, 90) 0%,
      rgb(10, 114, 235) 52%,
      rgb(1, 90, 156) 100%
    );
  "
>
  <!-- Fixed Header -->
  <nz-header
    class="!shrink-0 lg:!px-6 max-lg:!pr-4 max-lg:!pl-0 !h-16 !flex !items-center !justify-between !z-10 !border-b !border-white/10 !bg-transparent"
  >
    <!-- Logo -->
    <div class="flex items-center gap-3">
      <img app-image class="lg:h-12 max-lg:h-10" src="images/joetLogo.png" />
      <div class="hidden sm:block w-px h-5 bg-white/20"></div>
      <span
        class="hidden sm:block text-white text-[10px] tracking-[2.5px] uppercase font-semibold"
      >
        Legal Center
      </span>
    </div>

    <!-- Back link -->
    <a
      routerLink="/sign-up"
      class="flex items-center gap-2 rounded-lg px-3 py-2 text-white text-xs font-medium border border-white/15 bg-white/[0.07] hover:text-white hover:-translate-x-0.5 transition-transform duration-200"
    >
      <nz-icon nzType="arrow-left" nzTheme="outline" class="text-sm" />
      <span>Back to Register</span>
    </a>
  </nz-header>

  <!-- Middle: Sider + Content -->
  <nz-layout class="!flex-1 !overflow-hidden !bg-transparent">
    <!-- TOC Sider -->
    <nz-sider
      [nzWidth]="260"
      class="max-lg:!hidden !overflow-y-auto hide-scrollbar !border-r !border-white/10 !bg-transparent"
    >
      <div class="pt-6 px-5 h-full flex flex-col">
        <!-- TOC Label -->
        <div class="flex items-center gap-2 mb-5">
          <div
            class="w-0.5 h-4 rounded-full bg-gradient-to-b from-primary-500 to-primary-300"
          ></div>
          <p
            class="text-[10px] uppercase tracking-[2.5px] text-white font-semibold"
          >
            On this page
          </p>
        </div>

        <div
          class="flex flex-col gap-0.5 flex-1 overflow-y-auto hide-scrollbar"
        >
          @for (section of toc.sections(); track $index) {
            <button
              (click)="scrollToSection(section.id)"
              class="text-left text-white hover:text-white text-xs px-2 py-1.5 rounded-md hover:bg-white/[0.06] transition-all duration-200 truncate min-h-fit"
            >
              {{ $index + 1 }}. {{ section.title }}
            </button>
          }
        </div>
      </div>
    </nz-sider>

    <nz-content #scrollContainer class="!overflow-y-auto">
      <router-outlet></router-outlet>
    </nz-content>
  </nz-layout>

  <!-- Fixed Footer -->
  <nz-footer
    class="!shrink-0 !py-4 !px-8 !border-t !border-white/10 !bg-transparent"
  >
    <div
      class="flex items-center justify-between flex-wrap gap-3 max-lg:text-center"
    >
      <p class="text-white text-[11px]">
        Copyright &copy; {{ currentYear }} JOET Technologies LLC. All rights
        reserved.
      </p>
      <div class="flex items-center gap-1 max-lg:justify-center">
        <a
          routerLink="/legal/terms"
          class="text-[11px] text-white px-3 py-1.5 rounded-md hover:text-white/70 hover:bg-white/[0.06] transition-all duration-200"
        >
          Terms of Service
        </a>
        <a
          routerLink="/legal/fleet-terms"
          class="text-[11px] text-white px-3 py-1.5 rounded-md hover:text-white/70 hover:bg-white/[0.06] transition-all duration-200"
        >
          Fleet Terms
        </a>
        <a
          routerLink="/legal/policy"
          class="text-[11px] text-white px-3 py-1.5 rounded-md hover:text-white/70 hover:bg-white/[0.06] transition-all duration-200"
        >
          Privacy Policy
        </a>
      </div>
    </div>
  </nz-footer>
</nz-layout>
